module.exports = __webpack_public_path__ + "static/media/logo.339b30a9.png";